import React from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import { BiTrendingUp } from "react-icons/bi";
import styles from "./LineGraph.module.scss";

const LineGraph = ({ data, color, percentage }) => {
    return (
        <div className={styles.lineGraphContainer}>
            <div className={styles.percentageLabel}>
                <BiTrendingUp size={22} className={styles.arrowIcon} /> {percentage}%
            </div>

            <ResponsiveContainer width="100%" height={80}>
                <LineChart data={data}>
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke={color}
                        strokeWidth={3}
                        dot={false}
                        className={styles.glowingLine}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default LineGraph;